import { useState, useEffect } from 'react';

const useConvertExperiment = ({
  analytics,
  experimentId
}) => {
  const [convertExperiment, setConvertExperiment] = useState(null);
  useEffect(() => {
    if (!experimentId) {
      return;
    }
    const registrationId = analytics.convertExperiment.registerToExperimentUpdate(experimentId, experiment => {
      setConvertExperiment(experiment);
    });
    return () => analytics.convertExperiment.unregisterToExperiment(registrationId);
  }, [analytics, experimentId]);
  return convertExperiment;
};

let LandrMobileEventType = /*#__PURE__*/function (LandrMobileEventType) {
  LandrMobileEventType["AuthInit"] = "AuthInit";
  LandrMobileEventType["AuthIsAuthenticated"] = "AuthIsAuthenticated";
  LandrMobileEventType["AuthGetAccessToken"] = "AuthGetAccessToken";
  LandrMobileEventType["InitCompleted"] = "InitCompleted";
  LandrMobileEventType["InitFailed"] = "InitFailed";
  LandrMobileEventType["NavigateBack"] = "NavigateBack";
  LandrMobileEventType["NavigateToUrl"] = "NavigateToUrl";
  LandrMobileEventType["NavigateToMobileScreen"] = "NavigateToMobileScreen";
  LandrMobileEventType["PageDataLoaded"] = "PageDataLoaded";
  LandrMobileEventType["PageDataLoadFailed"] = "PageDataLoadFailed";
  LandrMobileEventType["OpenSubscriptionUpsell"] = "OpenSubscriptionUpsell";
  return LandrMobileEventType;
}({});

function sendReactNativeEvent(eventType, payload, log) {
  log?.info('Sending request to mobile', undefined, {
    eventType,
    data: payload
  });
  window.ReactNativeWebView.postMessage(JSON.stringify({
    type: eventType,
    data: payload
  }));
}
function addReactNativeEventListener(eventType, callback, log) {
  const listener = event => {
    if (event.detail && event.detail.type === eventType) {
      log?.info('Received response from mobile', undefined, {
        eventType,
        data: event.detail.data
      });
      callback(event.detail.data);
    }
  };
  window.addEventListener('react-native-message', listener);
  return () => {
    window.removeEventListener('react-native-message', listener);
  };
}

class TimeoutError extends Error {}
function sendWebViewEventToMobile(eventType, payload, log) {
  const responsePromise = new Promise((resolve, reject) => {
    const unsubscribe = addReactNativeEventListener(`response:${eventType}`, response => {
      unsubscribe();
      if (response.reject) {
        reject(new Error(response.reject));
      } else {
        resolve(response.resolve);
      }
    }, log);
  });
  sendReactNativeEvent(`request:${eventType}`, payload, log);
  return Promise.race([responsePromise, new Promise((_, reject) => setTimeout(() => {
    reject(new TimeoutError(`Timeout waiting for mobile event response: ${eventType}`));
  }, 5000))]).catch(e => {
    if (e instanceof TimeoutError) {
      log?.error(e.message);
    }
    throw e;
  });
}
function listenToMobileEventFromWebView(eventType, callback) {
  const unsubscribe = addReactNativeEventListener(`request:${eventType}`, callback);
  return () => {
    unsubscribe();
  };
}

function useMobileEventListener(eventType, callback) {
  useEffect(() => {
    const unsubscribe = listenToMobileEventFromWebView(eventType, callback);
    return unsubscribe;
  }, [eventType, callback]);
}
function useMobileEventBroadcast() {
  return (eventType, payload) => {
    return sendWebViewEventToMobile(eventType, payload);
  };
}

export { LandrMobileEventType, listenToMobileEventFromWebView, sendWebViewEventToMobile, useConvertExperiment, useMobileEventBroadcast, useMobileEventListener };
